import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "@/lib/api";
import { isProfileComplete } from "@/lib/storage";

export function ProtectedRoute({ children, requireProfile = true }) {
  const location = useLocation();

  if (!isAuthenticated()) {
    return <Navigate to="/auth" replace state={{ from: location.pathname }} />;
  }

  if (requireProfile && !isProfileComplete()) {
    return <Navigate to="/onboarding" replace />;
  }

  return children;
}
